<template src="./filtersCommon.pug" lang="pug"></template>

<script>
import FilterCommon from './FilterCommon'

export default {
  name: 'FiltersCommon',

  components: {
    FilterCommon
  },

  props: {
    data: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      quantity: this.data.filter(d => d.options.length > 0).length,
      sortedData: this.data.sort((a, b) => a.order - b.order)
    }
  }
}
</script>

<style scoped>
.filters-common {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  margin-left: 10px;
  font-family: 'Inter', sans-serif !important;
  font-size: 1em;
  cursor: pointer;
  letter-spacing: 0.01em;
}
</style>



// WEBPACK FOOTER //
// FiltersCommon.vue?5154ac10